export default __webpack_public_path__ + "static/media/Aarush_Tanwar_RESUME.cf5b5cd8.pdf";